export const Arrays = {
  /**
   * Generates an array of numbers from start to stop with a given step
   */
  range: ({ start, stop, step }: { start: number; stop: number; step: number }) => {
    return Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step)
  },

  /**
   * Splits an array into chunks of a given size
   */
  chunk: <T>(array: Array<T>, chunkSize: number) => {
    return Array.from({ length: Math.ceil(array.length / chunkSize) }, (_, index) =>
      array.slice(index * chunkSize, (index + 1) * chunkSize)
    )
  },

  /**
   * Returns all of the unique values in the array
   */
  unique: <T>(array: Array<T>) => {
    return Array.from(new Set(array))
  },

  /**
   * Filters out null and undefined values from an array
   */
  onlyDefinedValues: <T>(array: Array<T | null | undefined>) => {
    return array.filter((item) => item !== null && item !== undefined) as Array<T>
  }
}
